import ModalShare from './container';

export default ModalShare;
